import "./FirstLayer.css"

const FirstLayer = () => {
    return (
        <div className="FirstLayer">
            <h1>University Coursework</h1>
            <h2>Fall 2023 - Present: University of Alberta</h2>
            <div className="term-block">
                <h4>Winter 2026 (4th year) </h4>
                <ul>
                    <li>CMPUT 206: Introduction to Digital Image Processing</li>
                    <li>CMPUT 365: Introduction to Reinforcement Learning</li>
                    <li>SPH 200: Introduction to Public Health</li>
                    <li>SPH 300: Applied Public Health and Epidemiologic Principles</li>
                    <li>SPAN 112: Beginner's Spanish II</li>
                </ul>
                <h4>Fall 2025 (4th year) </h4>
                <ul>
                    <li>CMPUT 404: Web Applications and Architecture</li>
                    <li>CMPUT 328: Visual Recognition</li>
                    <li>CMPUT 461: Introduction to Natural Language Processing</li>
                    <li>SPAN 111: Beginner's Spanish I</li>
                </ul>
                <h4>Winter 2025 (3rd year) </h4>
                <ul>
                    <li>CMPUT 379: Operating Systems Concepts</li>
                    <li>CMPUT 291: Introduction to File and Database Management</li>
                    <li>ECON 299: Quantitative Methods in Economics</li>
                    <li>STAT 252: Introduction to Applied Statistics II</li>
                </ul>
                <h4>Fall 2024 (3rd year) </h4>
                <ul>
                    <li>CMPUT 301: Introduction to Software Engineering</li>
                    <li>CMPUT 366: Search and Planning in Artificial Intelligence</li>
                    <li>CMPUT 229: Computer Organization and Architecture I</li>
                    <li>MATH 225: Linear Algebra II</li>
                </ul>
                <h4>Winter 2024 (2nd year) </h4>
                <ul>
                    <li>CMPUT 201: Practical Programming Methodology</li>
                    <li>CMPUT 204: Algorithms I</li>
                    <li>CMPUT 267: Basics of Machine Learning</li>
                    <li>ASTRO 122: Astronomy of Stars and Galaxies</li>
                    <li>ECON 102: Introduction to Macroeconomics</li>
                </ul>
                <h4>Fall 2023 (2nd year) </h4>
                <ul>
                    <li>CMPUT 272: Formal Systems and Logic in Computing Science</li>
                    <li>MATH 214: Calculus III</li>
                    <li>ECON 101: Introduction to Microeconomics</li>
                    <li>STAT 265 (Dropped): Probability and Statistics I</li>
                </ul>
            </div>

            <h2>Fall 2022 - Winter 2023: 1st year at MacEwan University</h2>
            <div className="term-block">
                <h4>Spring 2023 (1st year) </h4>
                <ul>
                    <li>CMPT 200: Data Structures and Algorithms</li>
                    <li>MATH 200: (Dropped): Fundamental Concepts of Math</li>
                </ul>

                <h4>Winter 2023 (1st year) </h4>
                <ul>
                    <li>CMPT 103: Introduction to Computing II</li>
                    <li>MATH 115: Elementary Calculus II </li>
                    <li>ENGL 103: Approaches to Literature: Trends and Traditions</li>
                    <li>STAT 151: Introduction to Applied Statistics</li>
                </ul>
                <h4>Fall 2022 (1st year) </h4>
                <ul>
                    <li>CMPT 101: Introduction to Computing I</li>
                    <li>MATH 120: Basic Linear Algebra I</li>
                    <li>MATH 114: Elementary Calculus I</li>
                    <li>ENGL 102: Analysis and Argument</li>
                    <li>EASC 101: Introduction to Physical Science</li>
                </ul>
            </div>
        </div>
    )
}

export default FirstLayer